'use client'

import classNames from 'classnames'
import React, { useEffect, useRef, useState } from 'react'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  name: string
  margin?: 'default' | 'none'
  Tag?: React.ElementType
}

const BlockSection: React.FC<Props> = ({
  name,
  className,
  children,
  margin = 'default',
  Tag = 'section',
  ...rest
}) => {
  const reference = useRef()
  const [isVisible, setVisible] = useState(false)

  useEffect(() => {
    if (!reference.current || isVisible) return

    const onIntersect = ([entry]: IntersectionObserverEntry[]) => {
      if (entry.isIntersecting) {
        setVisible(true)
      }
    }

    const observer = new IntersectionObserver(onIntersect, {
      rootMargin: '0px 0px -25% 0px',
    })

    observer.observe(reference.current as Element)

    return () => observer.disconnect()
  }, [isVisible])

  return (
    <Tag
      ref={reference}
      className={classNames(name, className, {
        'animation-visible': isVisible,
        'my-10 md:my-20': margin === 'default',
      })}
      {...rest}
    >
      {children}
    </Tag>
  )
}

export default BlockSection
